import React, {Fragment} from 'react';
import {Col, Row} from 'react-bootstrap';
import autobind from 'autobind-decorator';
import {BaseComponent} from "../../BaseComponent";

import {ConfirmationDialog} from '../ConfirmationDialog';
import {GenericModelViewer} from '../GenericModelViewer';

import {FileUpload} from '../../../Models/StreamBank/FileUpload';
import {SB_ENTER_KEY_CODE} from "../../../Constants";
import {KeyboardUtils} from "../../../Utils";

const model = new FileUpload();

export class FileEditOverlay extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            showDelete: false
        }
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    @autobind
    handleKeyDown(e) {
        if (this.props.Display) {
            KeyboardUtils.handleKeyPress(SB_ENTER_KEY_CODE, e, () => this.onSaveClick());
        }
    }

    @autobind
    onCloseClick() {
        const { OnClose } = this.props;

        if(OnClose) {
            OnClose();
        }
    }

    @autobind
    onSaveClick() {
        const { OnSave } = this.props;

        if(OnSave) {
            OnSave();
        }
    }

    @autobind
    onDeleteClick() {
        const { OnDelete } = this.props;

        if(OnDelete) {
            OnDelete();
        }
    }

    @autobind
    updateFile(file) {
        const { OnUpdate } = this.props;

        if(OnUpdate) {
            OnUpdate(file);
        }
    }

    @autobind
    updateValidation(validation, editorGuid) {
        const { OnValidationUpdate } = this.props;

        if(OnValidationUpdate) {
            OnValidationUpdate(validation, editorGuid);
        }
    }

    @autobind
    isValid() {
        const { Validation } = this.props;

        for(const propertyName in Validation) {
            if(!Validation[propertyName].valid) {
                return false;
            }
        }

        return true;
    }

    render() {
        const { Display, File, CanDelete, OnDelete } = this.props;

        if(!File || !Display) {
            return null;
        }

        return <Fragment>
            <ConfirmationDialog
                size="lg"
                Title={File.name}
                Body={
                    <Row>
                        <Col xs={12}>
                            <GenericModelViewer
                                Data={File}
                                IsNewModel={false}
                                EditMode={true}
                                Model={model}
                                Update={this.updateFile}
                                OnValidationUpdate={this.updateValidation}
                                DefaultSelectedFieldDefKey={"name"}
                            />
                        </Col>
                    </Row>
                }
                CancelButtonMessage="Cancel"
                ConfirmationButtonMessage="Save"
                Display={Display && !this.state.showDelete}
                OnDelete={OnDelete ? () => this.setState({showDelete: true}) : null}
                OnClose={this.onCloseClick}
                OnConfirm={this.onSaveClick}
                DisableConfirmationButton={!this.isValid()}
                DisableDeleteButton={!CanDelete}
            />
            <ConfirmationDialog
                Title="Confirmation"
                Body={`Are you sure you want to delete ${File.name}?`}
                Display={this.state.showDelete}
                OnConfirm={() => this.onDeleteClick()}
                OnClose={() => this.setState({showDelete: false})}
            />
        </Fragment>;
    }
}


